import { Wallet } from 'lucide-react'
import type { Currency } from '@/types/payment'
import { getDepositActionButtonClassName } from '@/components/deposit/styles'
import { Input } from '@/components/ui/input'
import { Button } from '../ui/button'

interface AmountStepProps {
	currency: Currency
	currencyLabel: string
	amount: string
	onAmountChange: (value: string) => void
	onSubmit: () => void
	canSubmit: boolean
	isSubmitting: boolean
}

export function AmountStep({ currency, currencyLabel, amount, onAmountChange, onSubmit, canSubmit, isSubmitting }: AmountStepProps) {
	const isActionEnabled = canSubmit && !isSubmitting

	return (
		<div className='flex min-h-0 flex-1 flex-col gap-6'>
			<p className='text-sm font-medium tracking-[-0.21px] text-muted-foreground'>Minimum deposit amount: {currency.min_deposit}</p>
			<Input
				variant='icon'
				icon={<Wallet className='h-5 w-5' />}
				inputMode='decimal'
				value={amount}
				disabled={isSubmitting}
				onChange={(event) => {
					const nextValue = event.target.value.replace(/[^\d.]/g, '').replace(/(\..*)\./g, '$1')
					onAmountChange(nextValue)
				}}
				placeholder='0'
				className='min-w-0 flex-1 bg-transparent text-base font-semibold tracking-[-0.24px] text-foreground outline-none placeholder:text-muted-foreground'
				aria-label={`Deposit amount for ${currencyLabel}`}
			/>
			<Button type='button' onClick={onSubmit} disabled={!isActionEnabled} variant='primary'>
				Deposit
			</Button>
		</div>
	)
}
